import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Typography } from '../../components/ui/Typography';
import { formatDisplayUrl } from '../../lib/formatUrl';
import { ContentStatusPanel } from './ContentStatusPanel';
import type { VenueData } from './types';

interface VenueOverviewProps {
  venue: VenueData;
}

export const VenueOverview = ({ venue }: VenueOverviewProps) => {
  const navigate = useNavigate();

  return (
    <div className="bg-surface-secondary border border-border-default rounded-lg p-6 mb-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <Typography variant="heading4" as="h2" className="text-text-primary mb-2">
            Venue Overview
          </Typography>
          <p className="text-text-secondary">
            Manage your venue's basic information, contact details, and settings.
          </p>
        </div>
        <div className="flex-shrink-0">
          <Button
            onClick={() => navigate(`/wineries/${venue._id}/edit`)}
            className="w-full sm:w-auto"
          >
            Edit
          </Button>
        </div>
      </div>

      {/* Quick venue info display */}
      <div className="mt-6 pt-6 border-t border-border-default">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <Typography variant="label" as="h3" className="text-text-primary mb-2">
              Basic Information
            </Typography>
            <div className="space-y-1 text-sm text-text-secondary">
              <div><span className="font-medium">Type:</span> {venue.venueType}</div>
              <div><span className="font-medium">Location:</span> {venue.address.city}, {venue.address.state}</div>
              {venue.phone && <div><span className="font-medium">Phone:</span> {venue.phone}</div>}
              {venue.website && (
                <div>
                  <span className="font-medium">Website:</span>{' '}
                  <a
                    href={venue.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-700 hover:text-primary-800 hover:underline"
                  >
                    {formatDisplayUrl(venue.website)}
                  </a>
                </div>
              )}
            </div>
          </div>

          <ContentStatusPanel venue={venue} />
        </div>
      </div>
    </div>
  );
};
